{#if isLoading}
    <div class="absolute w-full h-full left-0 top-0 bg-white opacity-75 flex justify-center items-center">
        <div class="lds-dual-ring"></div>
    </div>
{/if}

<div class="site--content">
    <Navbar/>
    <div class="p-5 py-10">
        <div class="max-w-7xl mx-auto">

            <div class="flex mb-8 ">
                <div class="pr-10">
                    <label for="endpoint" class="mb-1 inline-block">Wähle einen Endpunkt:</label><br>
                    <select id="endpoint" class="h-10 w-64 inline transition shadow py-2 block px-2 bg-gray-100 rounded focus:outline-none hover:bg-gray-200"
                            on:change="{setEndpoint}">
                        {#each validDpEndpoints as endpoint}
                            {#if Filter.endpoint === endpoint.name}
                                <option selected value="{endpoint.name}">{endpoint.label}</option>
                            {:else}
                                <option value="{endpoint.name}">{endpoint.label}</option>
                            {/if}
                        {/each}
                    </select>
                </div>
            </div>

            <FilterList filterArray={filterArray}
                        config={Filter.config}
                        on:addFilter={addFilter}
                        on:updateFilter={updateFilter}
                        on:removeFilter={removeFilter}
            />

            <div class="flex justify-center flex-wrap mt-12">
                {#if generatedUrl}
                    <div class="text-center w-full mt-8">
                        <span class="text-center py-2 px-3 inline-block rounded break-all">
                            <span class="inline-block mr-2 font-bold text-blue-drkn">Abfrage URL:</span><span id="generated-url">{ generatedUrl }</span>
                            <button on:click={copyUrl}
                                    class="mt-2 mx-auto py-1 px-2 bg-blue-drkn text-white text-sm rounded shadow focus:outline-none flex hover:bg-sky-400 transition">Kopieren</button>
                        </span>
                    </div>
                {/if}
            </div>

            {#if showExecuteButton}
                <ResultsTable filterArray={filterArray}
                              results="{results}"
                              resource="{Filter.endpoint}"
                              on:fetchResults={fetchResults}
                />
            {:else}
                <div class="text-center mt-8">
                    <span class="text-center py-2 px-3 inline-block rounded break-all">
                        <span class="inline-block mr-2 font-bold">Die Abfrage ist nur in Anwendungen des Münsterland e.V. möglich, da eine weitere Verarbeitung der Abfrage URL notwendig ist.</span>
                    </span>
                </div>
            {/if}

        </div>
    </div>
</div>

<script>
    import Navbar from './components/navbar.svelte';
    import FilterList from './components/filter-list.svelte';
    import ResultsTable from './components/results-table.svelte';
    import config from "./config.json";
    import Filter from "./filter";
    import {onMount} from "svelte";

    export let endpoint;

    export let fromUrl;

    export let validDpEndpoints;

    let isLoading = true;

    let showExecuteButton = true;

    let generatedUrl = "";

    let filterArray = [];

    let results = [];

    onMount(async () => {
        config.dpmsEndpoint = endpoint;
        Filter.config = config;
        if (validDpEndpoints.length) {
            validDpEndpoints = config.endpoints.filter(endpoint => {
                return validDpEndpoints.includes(endpoint.name);
            });
            Filter.setEndpoint(validDpEndpoints[0].name);
        } else {
            validDpEndpoints = Filter.config.endpoints;
            Filter.setEndpoint(Filter.config.endpoints[0].name);
        }
        if (fromUrl) {
            await buildFilterSetupFromUrl();
        } else {
            await loadDataportalData();
        }

        isLoading = false;
    });

    async function loadDataportalData() {
        await loadCharacteristics();
        await loadCharacteristicsForGroups();
        await loadDepartments();
        await loadTypes();
        await loadTargetGroups();
    }

    async function loadCharacteristics(page = 1) {
        Filter.config.datasources["characteristics"] = [];
        let forResource = Filter.getForResource();
        const url = `${Filter.config.dpmsEndpoint}characteristics?page[size]=200&filter[characteristics.${forResource}]=1&sort=characteristics.name&page[number]=${page}`
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const result = await response.json();
        if (result.data) {
            result.data.forEach(char => {
                Filter.config.datasources["characteristics"] = [...Filter.config.datasources.characteristics, {"id": char.id, "name": char.name, "set": "set4"}];
            });
            if (result.next_page_url) {
                await loadCharacteristics(page + 1);
            }
        }
    }

    async function loadCharacteristicsForGroups(page = 1) {
        Filter.config.datasources["characteristics_for_groups"] = [];
        let forResource = Filter.getForResource();
        const url = `${Filter.config.dpmsEndpoint}characteristic_groups?page[size]=200&filter[characteristic_groups.${forResource}]=1&page[number]=${page}&append=characteristics`
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const result = await response.json();
        if (result.data) {
            result.data.forEach(charGroup => {
                charGroup.characteristics.forEach(char => {
                    if (Filter.config.datasources["characteristics_for_groups"].some(item => item.id === char.id)) return;
                    Filter.config.datasources["characteristics_for_groups"] = [...Filter.config.datasources.characteristics_for_groups, {
                        "id": char.id,
                        "name": char.name,
                        "set": "set4"
                    }];
                });
            });
            if (result.next_page_url) {
                await loadCharacteristicsForGroups(page + 1);
            }
        }
    }


    async function loadDepartments(page = 1) {
        Filter.config.datasources["departments"] = [];
        const url = `${Filter.config.dpmsEndpoint}departments?sort=departments.name&page[size]=200&page[number]=${page}`
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const result = await response.json();
        if (result.data) {
            result.data.forEach(char => {
                Filter.config.datasources["departments"] = [...Filter.config.datasources.departments, {"id": char.id, "name": char.name}];
            });
            if (result.next_page_url) {
                await loadDepartments(page + 1);
            }
        }
    }

    async function loadTypes(page = 1) {
        Filter.config.datasources["types"] = [];
        let forResource = Filter.getForResource();
        const url = `${Filter.config.dpmsEndpoint}types?filter[types.${forResource}]=1&sort=types.name&page[size]=200&page[number]=${page}`
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const result = await response.json();
        if (result.data) {
            result.data.forEach(char => {
                Filter.config.datasources["types"] = [...Filter.config.datasources.types, {"id": char.id, "name": char.name}];
            });
            if (result.next_page_url) {
                await loadTypes(page + 1);
            }
        }
    }

    async function loadTargetGroups(page = 1) {
        Filter.config.datasources["geographical_target_groups"] = [];
        const url = `${Filter.config.dpmsEndpoint}geographical_target_groups?page[size]=200&page[number]=${page}`
        const response = await fetch(url, {headers: {"X-Requested-With": "XMLHttpRequest"}});
        const result = await response.json();
        if (result.data) {
            result.data.forEach(char => {
                Filter.config.datasources["geographical_target_groups"] = [...Filter.config.datasources.geographical_target_groups, {"id": char.id, "name": char.name}];
            });
        }
    }

    async function setEndpoint() {
        isLoading = true;
        filterArray = [];
        results = [];
        Filter.config.datasources.characteristics = [];
        Filter.config.datasources.characteristics_for_groups = [];
        Filter.setEndpoint(this.value);
        await loadCharacteristics();
        await loadCharacteristicsForGroups();
        await loadTypes();
        generateUrl();
        isLoading = false;
    }

    function addFilter(event, res = "", value = "") {
        filterArray = [...filterArray, new Filter(res, value)];
        generateUrl();
    }

    function updateFilter(event) {
        const filterObject = event.detail.filterObject;
        const type = event.detail.type;
        const value = event.detail.value;

        showExecuteButton = true;
        if (filterObject.resource.name === "public_transport_line_geofence_external_id") {
            showExecuteButton = false;
        }

        filterArray = filterArray.map(item => {
            if (item !== filterObject) {
                return item;
            }

            if (type === 'resource') {
                filterObject.setResource(value);
            } else if (type === 'operator') {
                filterObject.setOperator(value);
            } else if (type === 'values') {
                filterObject.setValue(value);
            }

            return item;
        });

        generateUrl();
    }

    function removeFilter(event) {
        const filterObject = event.detail;
        filterArray = filterArray.filter(filter => filter.id !== filterObject.id);
        generateUrl();
    }

    function appendData() {
        const endpoint = Filter.config.endpoints.find(endpoint => endpoint.name === Filter.endpoint);
        let appendString = '';

        if (endpoint.appendings.filter && endpoint.appendings.filter.length) {
            endpoint.appendings.filter.forEach(filter => {
                appendString += `&filter[${filter}]=1`;
            })
        }

        appendString += `&append=${endpoint.appendings.append.join(",")}`;

        return appendString;
    }

    function generateUrl() {
        if (!filterArray.length) {
            generatedUrl = "";
            return;
        }

        generatedUrl = Filter.endpoint;

        let queryArray = [];

        filterArray.forEach(filter => {
            if (filter.getValue()) {
                queryArray.push(filter.getFilterUrlString());
            }
        });

        generatedUrl += `?${queryArray.join("&")}${appendData()}`;
    }

    function copyUrl() {
        navigator.clipboard.writeText(generatedUrl);
    }

    async function buildFilterSetupFromUrl() {
        generatedUrl = fromUrl;
        const fromUrlSplit = fromUrl.split('?');
        const filterString = fromUrlSplit[1];
        const filterItems = filterString.split('&');

        Filter.setEndpoint(fromUrlSplit[0]);

        await loadDataportalData();

        filterItems.forEach(item => {
            const itemSplit = item.split(/=(.*)/s);
            const filterResourceMatch = itemSplit[0].match(/filter\[(.*?)\]/);
            const value = itemSplit[1];

            if (!Array.isArray(filterResourceMatch)) return;

            const filterResource = filterResourceMatch[1];

            let filterConfig = Filter.config.filter.find(filter => filter.name == filterResource);
            if (!filterConfig || !filterConfig.hasOwnProperty('validFor') || filterConfig.validFor.includes(Filter.endpoint)) {
                addFilter(null, filterResource, value);
            }

        });
    }

    async function fetchResults() {
        isLoading = true;
        let response = await fetch(endpoint + generatedUrl, {
            method: "GET",
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        });
        results = await response.json();
        isLoading = false;
    }

</script>

<style>
    .lds-dual-ring {
        display: inline-block;
        width: 80px;
        height: 80px;
    }

    .lds-dual-ring:after {
        content: " ";
        display: block;
        width: 64px;
        height: 64px;
        margin: 8px;
        border-radius: 50%;
        border: 6px solid #111;
        border-color: #111 transparent #111 transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }

    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>